module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3-8b210644da900c55956315de8698e6d9.jpg";